/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "OpenRegisterPageService";
const log: any = LoggerModule.getInstance();

export class OpenRegisterPageService {
  private static instance: OpenRegisterPageService;

  private constructor(props: any = {}) {}

  public static getInstance(props: any = {}): OpenRegisterPageService {
    if (!OpenRegisterPageService.instance) {
      OpenRegisterPageService.instance = new OpenRegisterPageService(props);
    }
    return OpenRegisterPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;

    const agent = getAgent();
    const { token, decoded } = await agent?.parseAndDecodeToken({
      signerPK: this.signerPK,
    });
    content = {
      ...content,
      initialData: {
        email: decoded?.email,
        firstName: decoded?.firstName,
        lastName: decoded?.lastName,
      },
      token: token,
      isPassword: decoded?.authType === "PASSWORD",
    };
    return content;
  }

  public async getInviteUser() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = await agent.getInviteUserProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    // console.log("in the index=====", content);

    return content;
  }

  public async sendPurchaseInvite(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.sendPurchaseInviteUser(args);
  }
  public async validateReferral(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.validateReferral(args);
  }
}
